import React, { useRef, useEffect } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, useGLTF } from '@react-three/drei';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import * as THREE from 'three';

gsap.registerPlugin(ScrollTrigger);

function PreWorkoutMaxedModel({ modelRef }: { modelRef: React.MutableRefObject<THREE.Group | null> }) {
  const gltf = useGLTF('/models/preworkout-maxed.glb');
  const scene = Array.isArray(gltf) ? gltf[0].scene : gltf.scene;
  return <primitive ref={modelRef as any} object={scene} scale={[4.788, 4.788, 4.788]} position={[0, 0.5, 0]} />;
}

const InteractiveProductImageMaxed = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const modelRef = useRef<THREE.Group | null>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const container = containerRef.current;

    const baseRotation = Math.PI * 1.7;
    const totalTurns = 2;

    const st = ScrollTrigger.create({
      trigger: container,
      start: 'top bottom',
      end: 'bottom top',
      scrub: 0.243,
      onUpdate: (self) => {
        const progress = self.progress;
        const targetRotation = baseRotation + progress * Math.PI * 2 * totalTurns;
        if (modelRef.current) {
          modelRef.current.rotation.y = targetRotation;
        }
      },
    });

    return () => {
      st.kill();
    };
  }, []);

  return (
    <div className="relative -mt-8 h-auto" ref={containerRef}>
      <div className="sticky top-8 h-[400px] sm:h-[500px] md:h-[600px] lg:h-[800px]">
        <div className="relative h-[400px] sm:h-[500px] md:h-[600px] lg:h-[800px] w-full bg-gradient-to-br from-brand-darkBlack/90 to-brand-darkBlack rounded-lg overflow-hidden shadow-2xl">
           <Canvas 
            camera={{ position: [0, 6, window.innerWidth < 768 ? 24 : 18], fov: 60 }}
            style={{ background: 'transparent' }}
            gl={{ alpha: true, antialias: true }}
          >
            <ambientLight intensity={0.6} />
            <directionalLight position={[8, 8, 4]} intensity={1.2} castShadow />
            <directionalLight position={[-4, -4, -2]} intensity={0.4} />
            <pointLight position={[-8, -8, -4]} intensity={0.8} color="#FF4444" />
            <PreWorkoutMaxedModel modelRef={modelRef} />
            <OrbitControls 
              enableZoom={false} 
              enablePan={false}
              enableRotate={true}
              enableDamping={true}
              dampingFactor={0.05}
              autoRotate={false}
            />
          </Canvas>

          {/* Product badge */}
          <div className="absolute -bottom-2 -right-4 bg-red-500 text-foreground px-4 py-2 rounded-lg font-bold">
            100 serveringer
          </div>
        </div>
      </div>
    </div>
  );
};

export default InteractiveProductImageMaxed;
